import React from 'react';
import { EditorState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
// import draftToHtml from 'draftjs-to-html';
// import htmlToDraft from 'html-to-draftjs';
import PropTypes from 'prop-types';
import { RichUtils } from 'draft-js';

// import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
// import draftToMarkdown from 'draftjs-to-markdown';

export default function WEditor(props) {
    // const [editorState, setEditorState] = useState(EditorState.createEmpty());
    const editorState = props.editorState || EditorState.createEmpty();

    const onEditorStateChange = (editorState) => {
        // var convertedData = convertToRaw(editorState.getCurrentContent())
        props.handleChange(editorState);
    };

    return (
        <>
            <Editor
                editorState={editorState}
                wrapperClassName="demo-wrapper"
                editorClassName="demo-editor"
                onEditorStateChange={onEditorStateChange}
                toolbarCustomButtons_={[<VideoButton />]}
            />
        </>
    );
}

class VideoButton extends React.Component {
    static propTypes = {
        onChange: PropTypes.func,
        editorState: PropTypes.object,
    };

    toggleBold = () => {
        const { editorState, onChange } = this.props;
        const newState = RichUtils.toggleInlineStyle(
            editorState,
            'BOLD',
        );
        if (newState) {
            onChange(newState);
        }
    };

    render() {
        return (
            <div className="rdw-storybook-custom-option" onClick={this.toggleBold}>B</div>
        );
    }
}

